import slug from '@teko/slug';
import { t } from 'i18n';
import React from 'react';
// TODO: replace teko/ui with DS
import { CartPromotion } from '@teko/cart/v2';
import { CustomLink } from '@teko/ds-desktop';
import { ProductCheckoutInfo } from '@teko/ecommerce';
import { getTrackingData } from '@teko/tracking';
import { Button, Currency, styled } from '@teko/ui';
import { EmptyCartPanel } from 'components/EmptyCartPanel';
import { useCartV2 } from 'contexts';
import { useFormatNumber } from 'hooks';

export const MiniCart: React.FunctionComponent<MiniCartProps> = ({
  onHide,
  showShippingFee = true,
}: MiniCartProps) => {
  const {
    flattenItems,
    cart: { grandTotalAmount },
  } = useCartV2();
  const formatNumber = useFormatNumber();

  if (flattenItems.length === 0) {
    return (
      <Wrapper>
        <EmptyCartWrapper>
          <StyledEmptyCartPanel />
        </EmptyCartWrapper>
      </Wrapper>
    );
  }

  //Cart shipping fee is deprecated
  const shippingFee = 0;
  return (
    <Wrapper>
      <Body>
        {flattenItems.map((item) => {
          const promotions: CartPromotion[] = [];
          item.promotions?.map((group) => {
            promotions.push(
              ...group.promotions.filter((promotion) => !!promotion.title),
            );
          });
          return (
            <ProductCheckoutInfo
              mb={3}
              key={item.id}
              imageUrl={item.imageUrl}
              name={item.title || item.name}
              price={item.price}
              quantity={item.quantity}
              {...(!!item.sku
                ? {
                    targetPath: `/${slug(item.title || item.name)}-s${
                      item.sku
                    }.html`,
                  }
                : {})}
              gifts={promotions
                .filter((promotion) => !!promotion.cartPromotionId)
                .map((promotion: CartPromotion) => ({
                  name: promotion.title,
                  imageUrl: promotion.imageUrl,
                  isDefault: true,
                }))}
              tags={item.tags}
              sku={item.sku}
              displayPrice={item.displayPrice}
              attributeDescription={item.attributeDescription}
              formatNumber={formatNumber}
            />
          );
        })}
      </Body>
      <Footer>
        <FooterLine>
          <span>
            {t('Tổng tiền ({{totalCartItemsSelected}}) sản phẩm', {
              totalCartItemsSelected: flattenItems.length,
            })}
          </span>
          <GrandTotal>
            <Currency
              value={grandTotalAmount}
              formattedValue={formatNumber(grandTotalAmount)}
            />
          </GrandTotal>
        </FooterLine>
        {showShippingFee && shippingFee > 0 && (
          <FooterLine>
            <span>{t('Phí vận chuyển')}</span>
            <ShippingFee>
              <Currency
                value={shippingFee}
                formattedValue={formatNumber(shippingFee)}
              />
            </ShippingFee>
          </FooterLine>
        )}
      </Footer>
      <CustomLink href="/cart" as="/cart" passHref prefetch={false}>
        <div
          {...getTrackingData({
            isTrackContent: true,
            regionName: 'miniCart',
            contentName: 'viewCartFromMiniCart',
            target: 'shoppingCart',
          })}
        >
          <ViewCartButton variant="primary" block onClick={onHide}>
            {t('Xem giỏ hàng')}
          </ViewCartButton>
        </div>
      </CustomLink>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background-color: #fff;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  width: 384px;
  max-height: 400px;
`;

const ViewCartButton = styled(Button)`
  padding: 0.7rem 1rem;
  text-decoration: none;
  &:hover {
    color: #fff;
  }
`;
const EmptyCartWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Footer = styled.div`
  padding: 0.5rem 0;
  border-top: 1px dashed #e0e0e0;
`;
const FooterLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 26px;
`;
const Body = styled.div`
  height: 260px;
  overflow-y: auto;
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar {
    width: 6px;
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #999;
  }
`;
const StyledEmptyCartPanel = styled(EmptyCartPanel)`
  width: 250px;
`;
const GrandTotal = styled.span`
  font-size: 18px;
  font-weight: 500;
`;
const ShippingFee = styled.span`
  font-size: 14px;
`;
export interface MiniCartProps {
  onHide?: () => void;
  showShippingFee?: boolean;
}
